const parseCategory = (favCategory: string | null): string => {
  if (favCategory === 'practice-sheet') return 'Practice Mode';
  if (favCategory === 'alphabetical') return 'A-Z';
  if (favCategory === 'reverse-alphabetical') return 'Z-A';
  return favCategory
    ? favCategory.replace(/-/g, ' ').replace(/(\b[a-z](?!\s))/g, letter => letter.toUpperCase())
    : '';
};

const parseDuration = (totalSeconds?: number | null): string | null => {
  if (!totalSeconds) return null;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.max(totalSeconds - minutes * 60 - 1, 0);
  return seconds > 9 ? `${minutes}:${seconds}` : `${minutes}:0${seconds}`;
};

const parseInstrument = (instrument: string): string => {
  if (/-guitar/i.test(instrument)) {
    return 'guitar';
  }
  return instrument;
};

const parseCategorySlug = (category: string): string => {
  if (/practice-sheet/i.test(category)) {
    return 'practice';
  }
  return category;
};

export { parseCategory, parseDuration, parseInstrument, parseCategorySlug };
